import BrowseDelivery from "./BrowseDelivery";
import DetailDelivery from "./DetailDelivery";

const DeliveryRoute = {
    BrowseDelivery, DetailDelivery
}

export default DeliveryRoute